import React, { useState, useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import middleware from "../../Api/Middleware";
import ToastError from "../../Toasts/ToastError";
import { ButtonLightGrey } from "../../HouseStyle/Components/Buttons";
import "../ModalStyle.css";

function OpenEmailModal({ order_id, client_order_email_id, subject = "-" }) {
  const [show, setShow] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (show && order_id && client_order_email_id) {
      fetchEmailData();
    }
  }, [show, order_id, client_order_email_id]);

  const fetchEmailData = async () => {
    setIsLoading(true);
    try {
      const response = await middleware.get(`/orders/emails?order_id=${order_id}&client_order_email_id=${client_order_email_id}`);
      const emailResponse = response?.data?.data ?? response?.data ?? [];
      const formattedResponse = Array.isArray(emailResponse) ? emailResponse[0] : emailResponse;

      if (formattedResponse) {
        setEmailData(formattedResponse);
      } else {
        throw new Error('No email data found');
      }
    } catch (error) {
      ToastError(`Error fetching email: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const formattedSubject = useMemo(() => {
    if (!subject) return "-";
    return subject.length > 30 ? `${subject.slice(0, 30)}...` : subject;
  }, [subject]);

  const formatDateTime = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return new Intl.DateTimeFormat('nl-NL', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Amsterdam',
    }).format(date);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleShow}
        className="btn btn-link p-0 text-decoration-none email-subject text-start new-link-color"
      >
        {formattedSubject}
      </button>
      <Modal
        id="modalEmailDetails"
        show={show}
        onHide={handleClose}
        className="colormodals"
        size="xl"
        centered
      >
        <Modal.Header className="modalTop justify-content-between px-5">
          <h2 className="BlockTitle mb-0">E-maildetails</h2>
          <button type="button" className="btn" onClick={handleClose}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter">
          {isLoading ? (
            <p className="mb-0">E-mailgegevens worden geladen...</p>
          ) : emailData ? (
            <div className="d-flex flex-column gap-3">
              <div>
                <p className="mb-1 fw-semibold">Van</p>
                <p className="mb-0">{emailData.sender_email || '-'}</p>
              </div>
              <div>
                <p className="mb-1 fw-semibold">Naar</p>
                <p className="mb-0">{emailData.receiver_email || '-'}</p>
              </div>
              <div>
                <p className="mb-1 fw-semibold">Onderwerp</p>
                <p className="mb-0">{emailData.subject || '-'}</p>
              </div>
              <div>
                <p className="mb-1 fw-semibold">Datum</p>
                <p className="mb-0">{formatDateTime(emailData.created_at)}</p>
              </div>
              <div>
                <p className="mb-1 fw-semibold">Bericht</p>
                <div
                  className="p-3 bg-white rounded-3 border"
                  style={{ minHeight: "150px" }}
                  dangerouslySetInnerHTML={{ __html: emailData.content || '' }}
                />
                <p className="mt-3 mb-0 text-muted" style={{ fontSize: "13px" }}>
                  Voor het volledige bericht, kijk uw mail.
                </p>
              </div>
            </div>
          ) : (
            <p className="mb-0">Geen e-mailgegevens beschikbaar.</p>
          )}
        </Modal.Body>
        <Modal.Footer className="modalBottom">
          <div className="d-flex justify-content-end w-100">
            <ButtonLightGrey text="Sluiten" onClickFunction={handleClose} />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OpenEmailModal;